import React, { Component } from 'react'
import axios from './axios'
import Translate from '../components/translate/conf'
import ReactDOMServer from 'react-dom/server';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js'
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js'
import { Link } from 'react-router-dom';
import ModalLoading from '@app/components/modal-loading/modal-loading';

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class OltAlarmTable extends Component {

  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      mLoading: true
    }
  }

  getTableData = async () => {
    try {
      const res = await axios.get('/api/oltalarmtable')
      this.setState(
        {
          rows: res.data["data"],
          mLoading: false
        },
        () => {
          $(this.tbl).DataTable({
            "search": {
              "search": this.props.match.params.filter
            },
            "pageLength": 50,
            "lengthMenu": [0, 10, 20, 30, 40, 50],
            "responsive": true,
            "columnDefs": [
              {
                visible: false,
                targets: 0,
              },
              {
                targets: [1, 2, 3, 4],
                className: 'dt-center th-bg-blue td-blue'
              },
              {
                targets: [5],
                className: 'dt-center th-bg-blue td-blue',
                render: (value) => {
                  if ( value == "On") {
                    value = ReactDOMServer.renderToString(<div className='text-offline'><Translate transVar='OLT.Alarms.On' /></div>)
                  } else {
                    value = ReactDOMServer.renderToString(<div className='text-online'><Translate transVar='OLT.Alarms.Off' /></div>)
                  }
                  return value;
                }
              }
            ],
            "order" : [
              [ 1, 'desc' ]
            ],
            initComplete: function () {
              this.api()
                  .columns()
                  .every(function () {
                      var that = this;
                      $('input', this.footer()).on('keyup change clear', function () {
                          if (that.search() !== this.value) {
                              that.search(this.value).draw();
                          }
                      });
                  });
            },
          });
        }
      )
    } catch (e) { 
      console.log(e);
    }
  }

  componentDidMount() {
    this.getTableData();
  }

  tHeader = () => {
    return (
      <>
        <thead>
          <tr>
            <th></th>
            <th><Translate transVar='OLT.Alarms.DateTime'/></th>
            <th><Translate transVar='OLT.Alarms.Slot' /></th>
            <th><Translate transVar='OLT.Alarms.Label' /></th>
            <th><Translate transVar='OLT.Alarms.Alarms' /></th>
            <th><Translate transVar='OLT.Alarms.State' /></th>
          </tr>
        </thead>
      </>
    );
  }

  tFooter = () => {
    return (
      <>
        <tfoot>
          <tr>
            <td></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Alarms.DateTime' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Alarms.Slot' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Alarms.Label' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Alarms.Alarms' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Alarms.State' />)} /></td>
          </tr>
        </tfoot>
      </>
    );
  }

  tBody = () => {
    let arrTd = []
    this.state.rows.forEach((e, i) => {
      arrTd.push(
        <tr key={i}>
          <td>{e.id}</td>
          <td>{e.datetime}</td>
          <td>{e.slot_id}</td>
          <td>{e.label}</td>
          <td>{e.alarm}</td>
          <td>{e.state}</td>
        </tr>
      )
    });
    return (
      <>
        <tbody>{arrTd}</tbody>
      </>
    )
  }

  render() {
    return (
      <>
        <ModalLoading show={this.state.mLoading} />
        {!this.state.mLoading &&
          <table width="100%" ref={(tbl) => (this.tbl = tbl)} className='table table-striped'>
            <this.tHeader />
            <this.tBody />
            <this.tFooter />
          </table>
        }
      </>
    )
  }
}
